import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AaliTrustz = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.2 });
    document.querySelectorAll('.scroll-reveal, .service-item, .info-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="company-hero" style={{ background: 'linear-gradient(135deg, #0fa3e3, #22b0ea)' }}>
        <div className="hero-content">
          <h1>AALI TRUSTZ</h1>
          <p>Charitable foundation dedicated to education, healthcare, and community development initiatives</p>
        </div>
      </div>
      <div className="company-content">
        <div className="container">
          <div className="company-grid">
            <div className="left scroll-reveal">
              <h2>About AALI TRUSTZ</h2>
              <p>AALI TRUSTZ embodies our commitment to social responsibility. Through focused initiatives in education, healthcare, and community development, we strive to create lasting positive impact in communities we serve.</p>
              <h3>Our Services</h3>
              <div className="services-list">
                <div className="service-item"><span>✔</span> Education Programs</div>
                <div className="service-item"><span>✔</span> Healthcare Initiatives</div>
                <div className="service-item"><span>✔</span> Community Development</div>
                <div className="service-item"><span>✔</span> Skill Training</div>
                <div className="service-item"><span>✔</span> Women Empowerment</div>
              </div>
            </div>
            <div className="info-card scroll-reveal">
              <h4>Company Info</h4>
              <div className="info-block">
                <span className="info-label">Industry</span>
                <strong className="info-value">Social</strong>
              </div>
              <div className="info-block">
                <span className="info-label">Parent Company</span>
                <strong className="info-value">AALI GROUP</strong>
              </div>
              <div className="actions">
                <Link to="/contact" className="btn-primary">Get in Touch</Link>
                <Link to="/coming-soon" className="btn-primary">Visit Main Website</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AaliTrustz;